// Funzioni rilasciate prima agli operatori (admin/legals) e poi a tutti.
// Per aprirle ai clienti basta portare il flag a true nella release del martedì.
export const DASHBOARD_PERIOD_FOR_ALL = false;
export const IMPORT_LINKS_FOR_ALL = false;
